import { render, staticRenderFns } from "./WaybillLogoIndex.vue?vue&type=template&id=5638d3c4&"
import script from "./WaybillLogoIndex.vue?vue&type=script&lang=js&"
export * from "./WaybillLogoIndex.vue?vue&type=script&lang=js&"
import style0 from "./WaybillLogoIndex.vue?vue&type=style&index=0&id=5638d3c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports